<i18n
  src="@/locales/views/service_provider/services/container_op/show_schedule.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="sp_services_container_op_path"
    :params="{
      service_provider_id: service_provider_id,
    }"
  />
  <bread-crumbs :labels="[module_name]"></bread-crumbs>
  <div class="mt-8">
    <div class="panel"  v-if="container_scheduled_service">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.agro_exporter_id") }}
              </dt>
              <dd class="content-data">
                {{ container_scheduled_service.agro_exporter?.name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <template v-if="container_scheduled_service.container">
                <dt class="label-data">
                  {{ $t("model.container_scheduled_service.container_id") }}
                </dt>
                <dd class="content-data">
                  {{ container_scheduled_service.container?.container_code }}
                </dd>
              </template>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.scheduled_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.scheduled_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDTHH:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.status_id") }}
              </dt>
              <dd class="content-data">
                <container-scheduled-service-status
                  :status_id="container_scheduled_service.status_id"
                />
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.started_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.started_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDThh:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.finished_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.finished_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDTHH:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div
              class="sm:col-span-6"
              v-if="container_scheduled_service.observations"
            >
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.observations") }}
              </dt>
              <dd class="content-data">
                {{ container_scheduled_service.observations }}
              </dd>
            </div>
            <div
              class="sm:col-span-6"
              v-if="
                container_scheduled_service.container_schedule_technicians
                  .length > 0
              "
            >
              <dt class="label-data">
                {{
                  $t(
                    "model.container_scheduled_service.container_schedule_technicians"
                  )
                }}
              </dt>
              <dd class="content-data">
                {{
                  container_scheduled_service.container_schedule_technicians
                    .map((technician) => technician.user.name)
                    .join(", ")
                }}
              </dd>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer" v-if="container_scheduled_service">
        <div class="panel-footer-actions">
          <destroy-button
            :disabled_button="proc_button_destroy"
            @destroyEvent="destroySchedule()"
            :label="$t('labels.destroy_button_label')"
            :title="$t('labels.destroy_button_title')"
            :message="$t('labels.destroy_button_message')"
            :label_confirm="$t('labels.destroy_button_label_confirm')"
          />
          <span class="space-actions"></span>
          <white-button
            @click.prevent="goToEditContainerSchedule()"
            :label="container_scheduled_service.container
                ? $t('labels.change_container_button')
                : $t('labels.add_container_button')"
            icon="fa-solid fa-truck-container"
          />
          <span class="space-actions"></span>
          <white-button
            @click.prevent="goToEditTechnicians()"
            :label="$t('labels.edit_technicians')"
            icon="fa-regular fa-user-helmet-safety"
          />
          <span class="space-actions"></span>
          <edit-button
            @click.prevent="goToEditSchedule()"
            :label="$t('labels.edit_button')"
          />
        </div>
      </div>
    </div>
    <loading-message v-else />
  </div>
  <container-services
    :container_scheduled_service="container_scheduled_service"
  />
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/show_schedule.js";
import ContainerScheduledServiceStatus from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceStatus.vue";
import ContainerServices from "@/components/views/service_provider/services/container_op/show_schedule/ContainerServices.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: {
    BreadCrumbs,
    ContainerScheduledServiceStatus,
    ContainerServices,
  },
  props: ["service_provider_id", "container_scheduled_service_id"],
  data() {
    return {
      container_scheduled_service: null,
      proc_button_destroy: false,
    };
  },
  methods: {
    destroySchedule: async function () {
      if (this.proc_button_destroy) return;

      this.proc_button_destroy = true;
      try {
        let response = await Requester.destroy({
          container_scheduled_service_id: this.container_scheduled_service_id,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToListSchedules();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_button_destroy = false;
    },
    fetchSchedule: async function () {
      let response = await Requester.fetchSchedule({
        container_scheduled_service_id: this.container_scheduled_service_id,
      });
      let container_scheduled_service = response.data;
      container_scheduled_service.scheduled_at =
        container_scheduled_service.scheduled_at?.split(".")[0];
      container_scheduled_service.started_at =
        container_scheduled_service.started_at?.split(".")[0];
      container_scheduled_service.finished_at =
        container_scheduled_service.finished_at?.split(".")[0];
      this.container_scheduled_service = container_scheduled_service;
    },
    goToEditContainerSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_container_path",
        params: {
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToEditTechnicians: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_technicians_path",
        params: {
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToEditSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_schedule_path",
        params: {
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToListSchedules: function () {
      this.$router.push({
        name: "sp_services_container_op_path",
        params: {
          service_provider_id: this.service_provider_id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchSchedule();
      })
    );
  },
};
</script>
